// TODO: Needs Cleanup and consolidation with course-tile-menu
import { IQuery } from 'core-ts-types';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APCourse } from '../../../global/builders/ap_course_builder';
import { APGenericSlot, CourseSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APCourseInfoModel } from '../../../global/components/course_detail/models/course_info_model';
import { APCourseInfoQuery } from '../../../global/components/course_detail/queries/ap_course_info_query';
import { ISaveTermPayload, ITermEntry } from '../../../global/components/course_tile_menu/course_tile_course_menu';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { IAPCoursesDatasource } from '../../../global/datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../../../global/datasources/ap_planned_course_datasource';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APComponentStateModel } from '../../../global/models/ap_component_state_model';
import { APGenericSlotServant } from '../../../global/servants/ap_generic_slot_servant';
import { APMultiTermsQuery } from '../../../plan/queries/ap_mm_terms_query';
import { ICourseDetailsStateParams } from '../../../routes/ap_course_details_routes';
import { MarkAsMetFacade } from './../../../global/components/mark_as_met/facades/mark_as_met_facade';

class MmCourseDetailsMenuController {
  private isAdvisor: boolean;
  private genericSlot: CourseSlot;
  private isPlanned: boolean = false;
  private showLockCourseOption: boolean;
  private showUnlockCourseOption: boolean;
  private courseLock: boolean = false;
  private allowRemoveCourse: boolean = false;
  private addToTermMenuItemText: string;
  private popupMenuId: string;
  private isPast = false;
  private stateParams: Omit<ICourseDetailsStateParams, 'showCourseDetailsMenu'> = {
    courseId: INVALID_ID,
    courseNk: `${INVALID_ID}`,
    slotId: INVALID_ID,
    isPast: false,
    termId: INVALID_ID,
    plannedCourseId: INVALID_ID
  };
  constructor(
    private $state: ng.ui.IStateService,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngComponentCommunicatorService: CommunicatorService,
    private phxAxTitleAnnouncerDelegate: any,
    private ngAPCourseInfoModel: APCourseInfoModel,
    private ngAPCourseInfoQuery: APCourseInfoQuery,
    private ngAPMultiTermsQuery: APMultiTermsQuery,
    private saveMmCourseToTermCommand: ICommand,
    private loadMmAcademicPlanCommand: ICommand,
    private removeMmCourseFromTermCommand: ICommand,
    private unsaveFavoriteCourseCommand: ICommand,
    private loadMmFavoriteCoursesCommand: ICommand,
    private saveFavoriteCourseCommand: ICommand
  ) {
    this.popupMenuId = _4.uniqueId();
  }

  initialize() {
    this.stateParams = this.$state.params.courseDetailsParams;
    this.isPast = _4.get(this.stateParams, 'isPast', false);
    this.isAdvisor = this.ngAPUserModeConfig.isAdvisor();
    this.allowRemoveCourse = this.isFromTerm && !this.isPast && this.isPlannedCourse;
    this.addToTermMenuItemText = this.isFromTerm ? 'Move to Term' : 'Add Course to Term';
  }

  get isPlannedCourse() {
    return this.stateParams.status === 'PLANNED';
  }
  get showAddToTermOption() {
    return this.isFromTerm ? this.isPlannedCourse : true;
  }
  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  onMouseHover(event: any) {
    this.showLockCourseOption = !this.courseLock && this.isPlanned && this.isAdvisor;
    this.showUnlockCourseOption = this.courseLock && this.isPlanned && this.isAdvisor;
  }
  moveToTerm(term: ITermEntry) {
    const payload = {
      term: term.id,
      program_slot: this.stateParams.slotId,
      course: this.stateParams.courseId
    };
    if (this.isFromTerm) {
      this._removeCourseFromTerm().then((studentId) => {
        this._saveCourseToTerm(payload).then(() => {
          this.loadMmAcademicPlanCommand(studentId);
        });
      });
    } else {
      this._saveCourseToTerm(payload).then((studentId) => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    }
  }

  get isFromTerm() {
    return _4.gt(this.stateParams.termId, 0);
  }

  _saveCourseToTerm(payload: ISaveTermPayload) {
    return this.saveMmCourseToTermCommand(payload);
  }

  _removeCourseFromTerm() {
    return this.removeMmCourseFromTermCommand(this.stateParams.plannedCourseId);
  }
  removeCourse() {
    this._removeCourseFromTerm().then((studentId) => {
      this.loadMmAcademicPlanCommand(studentId);
    });
  }
  favoriteCourse() {
    this.toggleFavoriteCourse(`saveFavoriteCourseCommand`);
  }

  unfavoriteCourse() {
    this.toggleFavoriteCourse(`unsaveFavoriteCourseCommand`);
  }
  toggleFavoriteCourse(command: string) {
    const course = this.genericSlot.course;
    this[`${command}`](course).then((updatedCourse: APCourse) => {
      this.loadMmFavoriteCoursesCommand();
      const courseInfoToUpdate = this.ngAPCourseInfoModel.read();
      courseInfoToUpdate.course[`${updatedCourse.id}`] = updatedCourse;
      this.ngAPCourseInfoModel.write(courseInfoToUpdate);
    });
  }
}

class MmCourseDetailsMenu implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      genericSlot: '<'
    };
    this.controller = MmCourseDetailsMenuController;
    this.templateUrl =
      'capability-ng-academic-planner/src/smart_catalog/components/course_details_menu/mm_course_details_menu.html';
  }
}

angular.module('capability-ng-smartcatalog').component('mmCourseDetailsMenu', new MmCourseDetailsMenu());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/components/course_details_menu/mm_course_details_menu.ts